import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { SessionJobDataset } from '@data/session-job-dataset/session-job-dataset.model';

export interface SessionJobDatasetState
  extends
    EntityState<SessionJobDataset, SessionJobDataset['_id']>,
    ActiveState<SessionJobDataset['_id']> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'session-job-datasets', resettable: true, idKey: '_id' })
export class SessionJobDatasetStore extends EntityStore<SessionJobDatasetState> {
  constructor() {
    super();
  }
}
